/*
 * Author: Harper Yan
 * File Created: Friday, 24-07-12 02:57 pm
 * Last Modified: Monday, 24-11-25 11:06 am, by Roger
 */

import {
  filledInputClasses,
  formHelperTextClasses,
  inputBaseClasses,
  inputLabelClasses,
} from '@mui/material';
import {
  ComponentsOverrides,
  ComponentsProps,
  ComponentsVariants,
  Theme,
} from '@mui/material/styles';

type TextFieldThemeOptions = {
  defaultProps?: ComponentsProps['MuiTextField'];
  styleOverrides?: ComponentsOverrides<Theme>['MuiTextField'];
  variants?: ComponentsVariants<Theme>['MuiTextField'];
};

export const MuiTextField: TextFieldThemeOptions = {
  defaultProps: {
    variant: 'filled',
  },
  styleOverrides: {
    root: ({ theme, error }) => ({
      '& input:-webkit-autofill': {
        WebkitBoxShadow: '0 0 0 100px #252837 inset !important',
        borderRadius: '2px',
        WebkitTextFillColor: '#FFF !important',
      },
      '& input:-webkit-autofill:focus': {
        WebkitBoxShadow: '0 0 0 100px #252837 inset !important',
        borderRadius: '2px',
        WebkitTextFillColor: '#FFF !important',
      },
      '& input:-webkit-autofill:hover': {
        WebkitBoxShadow: '0 0 0 100px #252837 inset !important',
        borderRadius: '2px',
        WebkitTextFillColor: '#FFF !important',
      },
      '& input:-webkit-autofill:active': {
        WebkitBoxShadow: '0 0 0 100px #252837 inset !important',
        borderRadius: '2px',
        WebkitTextFillColor: '#FFF !important',
      },

      // Label
      [`& > .${inputLabelClasses.root}.${inputLabelClasses.root}`]: {
        position: 'relative',
        marginBottom: '10px',
        transform: 'none',
        maxWidth: 'none',
        fontSize: '14px',
        fontWeight: 400,
        lineHeight: '14px',
        color: '#707A8A',

        [`.${inputLabelClasses.focused}`]: {
          color: '#707A8A',
        },
      },

      // Helper Text Todo @design@harper
      [`& > .${formHelperTextClasses.root}`]: {
        marginTop: '4px',
      },
      // Fill Input
      [`& > .${filledInputClasses.root}`]: {
        padding: '13px 12px',
        margin: 0,
        borderRadius: '8px',
        background: '#252837',
        fontSize: '16px',
        fontWeight: 400,
        [`& > .${filledInputClasses.input}`]: {
          padding: 0,
          opacity: 1,
          height: '22px',
        },

        [`& > input::placeholder`]: {
          fontSize: '16px',
        },
        // multiline input + size medium
        [`&.${inputBaseClasses.multiline} `]: {
          padding: '16px',
        },
        // color
        [`&.${filledInputClasses.focused}`]: {
          //   borderWidth: '1px',
          //   borderStyle: 'solid',
          // ...(error && { borderColor: theme.palette.error.main, }),
        },
        // orders matters here
        // [`&.${filledInputClasses.error}`]: {
        //   border: `1px solid ${theme.palette.error.main}`,
        // },
        // // Icon adornment
        // [`& > .${inputAdornmentClasses.root} `]: {
        //   margin: 0,
        //   [`& > .${svgIconClasses.root} `]: {
        //     margin: '8px',
        //   },
        // },
        // [`&.${inputBaseClasses.adornedEnd}`]: {
        //   padding: '0 16px 0 16px',
        // },
        // [`&.${inputBaseClasses.adornedStart}`]: {
        //   padding: '0 16px 0 16px',
        // },
        // [`&.${inputBaseClasses.adornedStart}.${inputBaseClasses.adornedEnd}`]: {
        //   padding: '4px 0',
        // },
        // [`& > .${inputAdornmentClasses.positionEnd} `]: {
        //   padding: '4px',
        //   height: 'auto',
        //   maxHeight: 'none',
        // },
        // [`& > .${inputAdornmentClasses.positionEnd} > .${iconButtonClasses.root}`]:
        //   {
        //     marginRight: '0',
        //   },
        // [`& > .${inputAdornmentClasses.positionStart}.${inputAdornmentClasses.positionStart}.${inputAdornmentClasses.positionStart}.${inputAdornmentClasses.positionStart}`]:
        //   {
        //     marginTop: '0',
        //   },
        // [`& > .${inputAdornmentClasses.positionStart}`]: {
        //   padding: '12px',
        //   marginRight: '0',
        //   height: 'auto',
        //   maxHeight: 'none',
        // },
        // [`& > .${inputAdornmentClasses.root} > .${iconButtonClasses.root},&.${inputBaseClasses.root} > .${inputAdornmentClasses.positionEnd} >.${svgIconClasses.root}`]:
        //   {
        //     color: 'inherit',
        //   },
        // [`& > .${inputAdornmentClasses.root}  .${svgIconClasses.root}`]: {
        //   width: '24px',
        //   height: '24px',
        // },
        // disabled
        '&.Mui-disabled': {
          border: 'none',
        },

        'input[type="password"]': {
          // password  指定统一的字体
          fontFamily: `'Arial', 'Helvetica', sans-serif`,
        },
      },

      // [`$ .${filledInputClasses.input}:autofill`]: {

      // },
    }),
  },
};
